import {
    ADDING_CONTRIBUTOR,
    ADDING_CONTRIBUTOR_SUCCESS,
    ADDING_CONTRIBUTOR_FAILURE,
    RESET_ADDING_CONTRIBUTOR,
    GETTING_CONTRIBUTORS_BY_DASHBOARD,
    GETTING_CONTRIBUTORS_BY_DASHBOARD_SUCCESS,
    GETTING_CONTRIBUTORS_BY_DASHBOARD_FAILURE,
    RESET_GETTING_CONTRIBUTORS_BY_DASHBOARD,
    UPDATING_CONTRIBUTOR,
    UPDATING_CONTRIBUTOR_SUCCESS,
    UPDATING_CONTRIBUTOR_FAILURE,
    RESET_UPDATING_CONTRIBUTOR,
    DELETING_CONTRIBUTOR,
    DELETING_CONTRIBUTOR_SUCCESS,
    DELETING_CONTRIBUTOR_FAILURE,
    RESET_DELETING_CONTRIBUTOR
} from 'redux/reduxConstants';

const initialState = {
    addingContributor: false,
    addingContributorSuccess: false,
    gettingContributorsByDashboard: false,
    gettingContributorsByDashboardSuccess: false,
    updatingContributor: false,
    updatingContributorSuccess: false,
    deletingContributor: false,
    deletingContributorSuccess: false,
    contributors: {},
    error: '',
};

const contributor = (state = initialState, action) => {
    switch (action.type) {
        case ADDING_CONTRIBUTOR:
            let addingContributorState = { ...state };
            addingContributorState.addingContributor = true;

            return addingContributorState;

        case ADDING_CONTRIBUTOR_SUCCESS:
            let addingContributorSucessState = { ...state };
            addingContributorSucessState.addingContributor = false;
            addingContributorSucessState.addingContributorSuccess = true;

            return addingContributorSucessState;

        case ADDING_CONTRIBUTOR_FAILURE:
            let addingContributorFailureState = { ...state };
            addingContributorFailureState.addingContributor = false;
            addingContributorFailureState.error = action.error;

            return addingContributorFailureState;

        case RESET_ADDING_CONTRIBUTOR:
            let resetAddingContributorState = { ...state };
            resetAddingContributorState.addingContributorSuccess = false;

            return resetAddingContributorState;

        case GETTING_CONTRIBUTORS_BY_DASHBOARD:
            let gettingContributorsByDashboardState = { ...state };
            gettingContributorsByDashboardState.gettingContributorsByDashboard = false;

            return gettingContributorsByDashboardState;

        case GETTING_CONTRIBUTORS_BY_DASHBOARD_SUCCESS:
            let gettingContributorsByDashboardSuccessState = { ...state };
            gettingContributorsByDashboardSuccessState.gettingContributorsByDashboardState = false;
            gettingContributorsByDashboardSuccessState.gettingContributorsByDashboardSuccess = true;
            gettingContributorsByDashboardSuccessState.contributors = action.contributors;

            return gettingContributorsByDashboardSuccessState;

        case GETTING_CONTRIBUTORS_BY_DASHBOARD_FAILURE:
            let gettingContributorsByDashboardFailureState = { ...state };
            gettingContributorsByDashboardFailureState.gettingDashboardsForSite = false;
            gettingContributorsByDashboardFailureState.error = action.error;
    
            return gettingContributorsByDashboardFailureState;

        case RESET_GETTING_CONTRIBUTORS_BY_DASHBOARD:
            let resetGettingContributorsByDashboardState = { ...state };
            resetGettingContributorsByDashboardState.gettingDashboardsForSiteSuccess = false;
    
            return resetGettingContributorsByDashboardState;

        case UPDATING_CONTRIBUTOR:
            let updatingContributorState = { ...state };
            updatingContributorState.updatingContributor = true;

            return updatingContributorState;

        case UPDATING_CONTRIBUTOR_SUCCESS:
            let updatingContributorSuccessState = { ...state };
            updatingContributorSuccessState.updatingContributor = false;
            updatingContributorSuccessState.updatingContributorSuccess = true;

            return updatingContributorSuccessState;

        case UPDATING_CONTRIBUTOR_FAILURE:
            let updatingDashboardsFailureState = { ...state };
            updatingDashboardsFailureState.updatingContributor = false;
            updatingDashboardsFailureState.error = action.error;

            return updatingDashboardsFailureState;

        case RESET_UPDATING_CONTRIBUTOR:
            let resetUpdatingContributorState = { ...state };
            resetUpdatingContributorState.updatingContributorSuccess = false;

            return resetUpdatingContributorState;

        case DELETING_CONTRIBUTOR:
            let deletingContributorState = { ...state };
            deletingContributorState.deletingContributor = true;

            return deletingContributorState;

        case DELETING_CONTRIBUTOR_SUCCESS:
            let deletingContributorSuccessState = { ...state };
            deletingContributorSuccessState.deletingContributor = false;
            deletingContributorSuccessState.deletingContributorSuccess = true;
            
            return deletingContributorSuccessState;

        case DELETING_CONTRIBUTOR_FAILURE:
            let deletingContributorFailureState = { ...state };
            deletingContributorFailureState.error = action.error;
            deletingContributorFailureState.deletingContributor = false;

            return deletingContributorFailureState;

        case RESET_DELETING_CONTRIBUTOR:
            let resetDeletingContributor = { ...state };
            resetDeletingContributor.deletingContributorSuccess = false;
    
            return resetDeletingContributor;

        default:
            return state;            
    }
};

export default contributor;
